<div class="caddie sidebar bar-left" id="left-sidebar">
  <app-button-scroll-top
    *ngIf="explorerData.leftSidebarScrollTopButton"
    [buttonText]="'Go to top'"
    (callbackFun)="explorerData.leftSidebarScrollTopButton = $event"
  >
  </app-button-scroll-top>
  <div
    *ngIf="explorerData.selectedWrapper"
    class="column is-12 info-background"
    [ngClass]="{
      cancer: explorerData.selectedWrapper.type === 'CancerNode',
      drug:
        explorerData.selectedWrapper.type === 'Drug' &&
        explorerData.selectedWrapper.data.status === 'approved',
      drug_unapproved:
        explorerData.selectedWrapper.type === 'Drug' &&
        explorerData.selectedWrapper.data.status === 'unapproved'
    }"
  >
    <app-info-tile
      [wrapper]="explorerData.selectedWrapper"
      [wrapperCancerTypes]="explorerData.selectedWrapperCancerTypes"
      [wrapperComorbidities]="explorerData.selectedWrapperComorbidities"
      (updateSelectedWrapper)="explorerData.selectedWrapper = $event"
    ></app-info-tile>
  </div>

  <!-- Data Selector START -->
  <div
    class="columns is-multiline is-centered row-data-selector"
    *ngIf="!explorerData.selectedAnalysisToken"
  >
    <div class="column is-12 has-text-centered">
      <!-- Dataset Selector START -->
      <div class="columns is-vcentered">
        <div class="column is-4 has-text-left">
          <h6 class="title is-6">Dataset:</h6>
        </div>
        <div class="column">
          <app-dataset-tile
            [datasetItems]="explorerData.datasetItems"
            [selectedDataset]="explorerData.activeNetwork.selectedDataset"
            (selectedDatasetChange)="
              explorerData.activeNetwork.networkVisJs = null;
              explorerData.activeNetwork.selectedDataset = $event;
              explorerData.initCancerTypes($event)
            "
          >
          </app-dataset-tile>
        </div>
      </div>
      <!-- Dataset Selector END -->
    </div>

    <div class="column is-12 has-text-centered">
      <!-- Data Level Toggle START -->
      <div class="columns is-vcentered">
        <div class="column is-4 has-text-left">
          <h6
            class="title is-6"
            data-tooltip="Select which daraset to use for gene-gene interactions"
          >
            Gene Gene Interactions:
          </h6>
        </div>
        <div class="column">
          <app-interaction-dataset-tile
            [datasetItems]="explorerData.interactionGeneDatasetItems"
            [selectedDataset]="
              explorerData.activeNetwork.selectedInteractionGeneDataset
            "
            (selectedDatasetChange)="
              explorerData.activeNetwork.networkVisJs = null;
              explorerData.activeNetwork.selectedInteractionGeneDataset =
                $event;
              buildMainNetwork()
            "
          >
          </app-interaction-dataset-tile>
        </div>
        <!-- Data Level Toggle END -->
      </div>
    </div>

    <div class="column is-12 has-text-centered">
      <!-- Cancer Type Selector START -->

      <div class="columns is-vcentered">
        <div class="column is-4 has-text-left">
          <h6 class="title is-6">Cancer Type:</h6>
        </div>
        <div class="column is-6">
          <app-cancertype-tile
            [cancerTypeItems]="explorerData.cancerTypes"
            [selectedCancerTypeItems]="
              explorerData.activeNetwork.selectedCancerTypeItems
            "
            (selectedCancerTypeItemsChange)="
              explorerData.activeNetwork.networkVisJs = null;
              explorerData.numberGenesInComorbidities = null;
              explorerData.activeNetwork.selectedCancerTypeItems = $event;
              buildMainNetwork()
            "
          >
          </app-cancertype-tile>
          <div *ngIf="explorerData.numberGenesInComorbidities" class="info">
            <p>
              {{ explorerData.numberGenesInComorbidities }} cancer driver genes
              found
            </p>
          </div>
        </div>
        <div class="column is-2"></div>
      </div>

      <div>
        <app-cancertype-comorbidities-tile
          [selectedCancerTypeItems]="
            explorerData.activeNetwork.selectedCancerTypeItems
          "
          [selectedCancerDataset]="explorerData.activeNetwork.selectedDataset"
          [selectedCancerTypeComorbidityGraph]="
            explorerData.selectedCancerTypeComorbidityGraph
          "
          (selectedDisease)="
            explorerData.activeNetwork.addVisibleGenesBasedOnComorbidity($event)
          "
          (numberGenesInComorbidities)="
            explorerData.numberGenesInComorbidities = $event
          "
        >
        </app-cancertype-comorbidities-tile>
      </div>
      <!-- Cancer Type Selector END -->
    </div>
  </div>
  <!-- Data Selector END -->

  <!-- Network Overview START -->
  <div class="card bar-large">
    <header class="card-header">
      <p class="card-header-title">
        <span class="icon">
          <i class="fas fa-info" aria-hidden="true"></i>
        </span>
        Network Overview
      </p>
      <a
        (click)="collapseOverview = !collapseOverview"
        data-action="collapse"
        class="card-header-icon is-hidden-fullscreen"
        aria-label="more options"
      >
        <span class="icon">
          <i
            *ngIf="collapseOverview"
            class="fas fa-angle-down"
            aria-hidden="true"
          ></i>
          <i
            *ngIf="!collapseOverview"
            class="fas fa-angle-left"
            aria-hidden="true"
          ></i>
        </span>
      </a>
    </header>
    <div *ngIf="collapseOverview">
      <div class="card-content">
        <nav class="level" *ngIf="explorerData.activeNetwork.networkData">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                Cancer <br />Genes
                <span
                  class="icon has-tooltip-right has-text-black is-lowercase has-text-weight-normal is-size-6"
                  data-tooltip="Displayed cancer genes and available
                      cancer genes, see 'Filter Cancer Genes'"
                >
                  <i class="fas fa-info-circle"></i>
                </span>
              </p>

              <p class="title">
                <span
                  *ngIf="
                    explorerData.activeNetwork.visibleCancerNodeCount !=
                    explorerData.activeNetwork.cancerNodes.length
                  "
                  >{{ explorerData.activeNetwork.visibleCancerNodeCount }} /
                </span>
                {{ explorerData.activeNetwork.cancerNodes.length }}
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                Genes
                <span
                  class="icon has-tooltip-bottom has-text-black is-lowercase has-text-weight-normal is-size-6"
                  data-tooltip="Only subgroup of genes is shown for performance reasons.
                        For the overview, just genes adjacent to cancer driver genes are considered"
                >
                  <i class="fas fa-info-circle"></i>
                </span>
              </p>
              <p class="title">
                <span
                  *ngIf="
                    explorerData.activeNetwork.visibleNodeCount !=
                    explorerData.activeNetwork.basicNodes.length
                  "
                  >{{ explorerData.activeNetwork.visibleNodeCount }} /
                </span>
                {{ explorerData.activeNetwork.basicNodes.length }}
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Interactions</p>
              <p class="title">
                <span
                  *ngIf="
                    explorerData.activeNetwork.visibleEdges.size !=
                    explorerData.activeNetwork.nodeData.edges.length
                  "
                  >{{ explorerData.activeNetwork.visibleEdges.size }} /
                </span>
                {{ explorerData.activeNetwork.nodeData.edges.length }}
              </p>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
  <!-- Network Overview END -->

  <!-- Find Network START -->
  <div class="card bar-large">
    <header class="card-header">
      <p class="card-header-title">
        <span class="icon">
          <i class="fas fa-search" aria-hidden="true"></i>
        </span>
        Find network nodes
      </p>
      <a
        (click)="collapseQuery = !collapseQuery"
        data-action="collapse"
        class="card-header-icon is-hidden-fullscreen"
        aria-label="more options"
      >
        <span class="icon">
          <i
            *ngIf="collapseQuery"
            class="fas fa-angle-down"
            aria-hidden="true"
          ></i>
          <i
            *ngIf="!collapseQuery"
            class="fas fa-angle-left"
            aria-hidden="true"
          ></i>
        </span>
      </a>
    </header>
    <div *ngIf="collapseQuery">
      <div class="card-content">
        <div class="field">
          <div class="control">
            <app-query-tile-component
              [queryItems]="explorerData.activeNetwork.queryItems"
              (selectItem)="explorerData.queryAction($event)"
              placeholder="Search..."
              removeOnSelect="false"
            ></app-query-tile-component>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Find Network END -->

  <!-- Filter Network START -->
  <div class="card bar-large">
    <header class="card-header">
      <p class="card-header-title">
        <span class="icon">
          <i class="fas fa-filter" aria-hidden="true"></i>
        </span>
        <span>Filter Cancer Driver Genes</span>
        <span
          class="icon has-tooltip-right has-text-black has-text-weight-normal is-size-6"
          data-tooltip="Filter or load more Cancer Driver Genes into graph"
        >
          <i class="fas fa-info-circle"></i>
        </span>
      </p>
      <a
        (click)="collapseBaitFilter = !collapseBaitFilter"
        data-action="collapse"
        class="card-header-icon is-hidden-fullscreen"
        aria-label="more options"
      >
        <span class="icon">
          <i
            *ngIf="collapseBaitFilter"
            class="fas fa-angle-down"
            aria-hidden="true"
          ></i>
          <i
            *ngIf="!collapseBaitFilter"
            class="fas fa-angle-left"
            aria-hidden="true"
          ></i>
        </span>
      </a>
    </header>
    <div *ngIf="collapseBaitFilter">
      <!-- Filter -->
      <app-filter-tile [cancerNodes]="explorerData.activeNetwork.cancerNodes">
      </app-filter-tile>
    </div>
  </div>
  <!-- Filter Network END -->

  <div class="card bar-large">
    <header class="card-header">
      <p class="card-header-title">
        <span class="icon">
          <i class="fas fa-flask" aria-hidden="true"></i>
        </span>
        Analysis
        <span
          class="icon has-tooltip-right has-text-black has-text-weight-normal is-size-6"
          data-tooltip="Run a sophisticated analysis based on selected nodes"
        >
          <i class="fas fa-info-circle"></i>
        </span>
      </p>
      <a
        (click)="collapseAnalysis = !collapseAnalysis"
        data-action="collapse"
        class="card-header-icon is-hidden-fullscreen"
        aria-label="more options"
      >
        <span class="icon">
          <i
            *ngIf="collapseAnalysis"
            class="fas fa-angle-down"
            aria-hidden="true"
          ></i>
          <i
            *ngIf="!collapseAnalysis"
            class="fas fa-angle-left"
            aria-hidden="true"
          ></i>
        </span>
      </a>
    </header>
    <div *ngIf="collapseAnalysis">
      <div class="card-content">
        <div class="field">
          <div class="control">
            <div class="columns mb-0">
              <div class="column is-half has-text-centered small-padding">
                <div class="analysis-option has-text-weight-bold example">
                  <span>Quick Start</span>
                </div>
              </div>
              <div class="column is-half has-text-centered small-padding">
                <div
                  class="analysis-option has-text-weight-bold"
                  [ngClass]="{ selected: analysis.getCount() > 0 }"
                >
                  <span
                    >Select Genes
                    <i class="fa fa-check" *ngIf="analysis.getCount() > 0"></i>
                  </span>
                </div>
              </div>
            </div>

            <div class="columns mb-0">
              <div class="column is-half has-text-centered small-padding">
                <button
                  (click)="
                    explorerData.exampleSearch('drug-target');
                    explorerData.deselectSelectedWrapper()
                  "
                  class="button is-example is-fullwidth has-tooltip"
                  data-tooltip="Find drug targets the cancer driver genes&#013; or selected genes."
                  [disabled]="explorerData.activeNetwork.networkVisJs === null"
                >
                  <span> Quick Target Search </span>
                </button>
              </div>
              <div class="column is-half has-text-centered small-padding">
                <button
                  (click)="
                    explorerData.analysisDialogTarget = 'drug-target';
                    explorerData.showAnalysisDialog = true;
                    explorerData.deselectSelectedWrapper()
                  "
                  class="button is-primary is-fullwidth has-tooltip"
                  data-tooltip="Find drug targets for the selected genes."
                  [disabled]="analysis.getCount() === 0"
                >
                  <span class="icon">
                    <i class="fa fa-crosshairs"></i>
                  </span>
                  <span> Find Drug Targets </span>
                </button>
              </div>
            </div>

            <div class="columns mb-0">
              <div class="column is-half has-text-centered small-padding">
                <button
                  (click)="
                    explorerData.exampleSearch('drug');
                    explorerData.deselectSelectedWrapper()
                  "
                  class="button is-example is-fullwidth has-tooltip"
                  data-tooltip="Find drugs for the cancer driver genes&#013; or selected genes."
                  [disabled]="explorerData.activeNetwork.networkVisJs === null"
                >
                  <span> Quick Drug Search </span>
                </button>
              </div>
              <div class="column is-half has-text-centered small-padding">
                <button
                  (click)="
                    explorerData.analysisDialogTarget = 'drug';
                    explorerData.showAnalysisDialog = true;
                    explorerData.deselectSelectedWrapper()
                  "
                  class="button is-primary is-fullwidth has-tooltip"
                  data-tooltip="Find drugs for the selected genes."
                  [disabled]="analysis.getCount() === 0"
                >
                  <span class="icon">
                    <i class="fa fa-capsules"></i>
                  </span>
                  <span> Find Drugs </span>
                </button>
              </div>
            </div>

            <div class="columns">
              <div class="column is-half has-text-centered small-padding"></div>
              <div class="column is-half has-text-centered small-padding">
                <button
                  (click)="explorerData.showTaskSummarizeDialog = true"
                  class="button is-primary is-fullwidth has-tooltip"
                  data-tooltip="Summarize two or more analysis results."
                  [disabled]="analysis.tasks.length < 2"
                >
                  <span class="icon">
                    <i class="fa fa-list-alt"></i>
                  </span>
                  <span> Summarize </span>
                </button>
              </div>
            </div>

            <div class="columns">
              <div class="column is-half has-text-centered small-padding"></div>
              <div class="column is-half has-text-centered small-padding">
                <app-g-profiler></app-g-profiler>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card bar-large">
    <header class="card-header">
      <p class="card-header-title">
        <span class="icon">
          <i class="fas fa-filter" aria-hidden="true"></i>
        </span>
        Selection ({{ analysis.getCount() }})
      </p>
      <a
        (click)="collapseSelection = !collapseSelection"
        data-action="collapse"
        class="card-header-icon is-hidden-fullscreen"
        aria-label="more options"
      >
        <span class="icon">
          <i
            *ngIf="collapseSelection"
            class="fas fa-angle-down"
            aria-hidden="true"
          ></i>
          <i
            *ngIf="!collapseSelection"
            class="fas fa-angle-left"
            aria-hidden="true"
          ></i>
        </span>
      </a>
    </header>
    <div *ngIf="collapseSelection" class="seed-selection">
      <div class="card-content overflow">
        <table
          class="table selection-table is-fullwidth"
          *ngIf="analysis.getCount() > 0"
        >
          <thead>
            <tr>
              <td>Type</td>
              <td>Name</td>
              <td>Entrez ID</td>
              <td>Uniprot Ac</td>
              <td>Actions</td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let g of analysis.getSelection()">
              <td>
                <span>
                  <i class="fa fa-dna" *ngIf="g.type == 'Node'">&nbsp;Gene</i>
                  <i class="fa fa-disease" *ngIf="g.type == 'CancerNode'"
                    >&nbsp;Cancer</i
                  >
                  <i class="fa fa-capsules" *ngIf="g.type == 'Drug'"
                    >&nbsp;Drug</i
                  >
                </span>
              </td>
              <td>{{ g.data.name }}</td>
              <td>{{ g.data.entrezId }}</td>
              <td>{{ g.data.uniprotAc }}</td>
              <td>
                <button
                  (click)="analysis.removeItems([g])"
                  class="button is-small is-danger is-outlined has-tooltip"
                  data-tooltip="Remove from selection."
                >
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <i *ngIf="analysis.getCount() === 0">
          Double-click on a node to select it for the analysis.
        </i>
      </div>

      <footer class="card-footer">
        <a
          (click)="
            analysis.addVisibleGenes(
              explorerData.activeNetwork.nodes,
              explorerData.activeNetwork.basicNodes
            )
          "
          class="card-footer-item has-text-success"
          data-tooltip="Add all visible genes."
        >
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>Add genes</span>
        </a>
        <a
          (click)="analysis.removeAllNodes()"
          class="card-footer-item has-text-danger"
          data-tooltip="Remove all genes."
        >
          <span class="icon">
            <i class="fa fa-minus"></i>
          </span>
          <span>Remove genes</span>
        </a>
      </footer>

      <footer class="card-footer">
        <a
          (click)="
            analysis.addVisibleCancerDriverGenes(
              explorerData.activeNetwork.nodes,
              explorerData.activeNetwork.cancerNodes
            )
          "
          class="card-footer-item has-text-success"
          data-tooltip="Add all visible cancer driver genes."
        >
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>Add cancer driver genes</span>
        </a>
        <a
          (click)="analysis.removeAllCancerDriverNodes()"
          class="card-footer-item has-text-danger"
          data-tooltip="Remove all cancer driver genes."
        >
          <span class="icon">
            <i class="fa fa-minus"></i>
          </span>
          <span>Remove cancer driver genes</span>
        </a>
      </footer>

      <footer class="card-footer" *ngIf="explorerData.selectedAnalysisToken">
        <a
          (click)="analysis.addSeeds(explorerData.activeNetwork.nodes)"
          class="card-footer-item has-text-success"
          data-tooltip="Add all visible seeds."
        >
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span> Add seeds </span>
        </a>
        <a
          (click)="analysis.removeSeeds(explorerData.activeNetwork.nodes)"
          class="card-footer-item has-text-danger"
          data-tooltip="Remove all seeds."
        >
          <span class="icon">
            <i class="fa fa-minus"></i>
          </span>
          <span> Remove seeds </span>
        </a>
      </footer>

      <footer class="card-footer">
        <a
          (click)="explorerData.showTissueThresholdDialog = true"
          class="card-footer-item has-text-primary"
          data-tooltip="Add genes based on expression in tissues."
        >
          <span class="icon">
            <i class="fa fa-angle-double-up"></i>
          </span>
          <span> Tissue expression </span>
        </a>
        <a
          (click)="explorerData.showCancerThresholdDialog = true"
          class="card-footer-item has-text-primary"
          data-tooltip="Add genes based on expression in cancer types."
        >
          <span class="icon">
            <i class="fa fa-angle-double-up"></i>
          </span>
          <span> Cancer expression </span>
        </a>
      </footer>

      <footer class="card-footer">
        <a
          (click)="explorerData.showDiseaseSelectionDialog = true"
          class="card-footer-item has-text-primary"
          data-tooltip="Add genes based on their occurrence in diseases."
        >
          <span class="icon">
            <i class="fa fa-upload"></i>
          </span>
          <span> Disease genes </span>
        </a>
        <a
          (click)="explorerData.showCustomGenesDialog = true"
          class="card-footer-item has-text-primary"
          data-tooltip="Add a custom list of genes."
        >
          <span class="icon">
            <i class="fa fa-upload"></i>
          </span>
          <span> Custom genes </span>
        </a>
      </footer>

      <footer class="card-footer">
        <a
          (click)="explorerData.activeNetwork.addSelectionToNetwork()"
          class="card-footer-item has-text-primary"
          data-tooltip="Add genes from selection to network."
        >
          <span class="icon">
            <i class="fa fa-project-diagram"></i>
          </span>
          <span> Add to Network </span>
        </a>

        <a
          (click)="explorerData.showVCFInput = true"
          class="card-footer-item has-text-primary"
          data-tooltip="Add genes from VCF-file to selection."
        >
          <span class="icon">
            <i class="fa fa-upload"></i>
          </span>
          <span> Upload VCF </span>
        </a>
      </footer>

      <footer class="card-footer">
        <a
          (click)="analysis.invertSelection(explorerData.activeNetwork.nodes)"
          class="card-footer-item has-text-primary"
          data-tooltip="Invert the current selection."
        >
          <span class="icon">
            <i class="fa fa-sync"></i>
          </span>
          <span> Invert </span>
        </a>

        <a
          (click)="explorerData.showMutationThresholdDialog = true"
          class="card-footer-item has-text-primary"
          data-tooltip="Add genes based on mutation in tissues."
        >
          <span class="icon">
            <i class="fa fa-angle-double-up"></i>
          </span>
          <span> Mutated genes </span>
        </a>
      </footer>
      <footer class="card-footer">
        <a
          (click)="analysis.resetSelection()"
          class="card-footer-item has-text-danger"
          data-tooltip="Remove all entries from the selection."
        >
          <span class="icon">
            <i class="fa fa-broom"></i>
          </span>
          <span> Reset </span>
        </a>
      </footer>
    </div>
  </div>

  <div class="card bar-large">
    <header class="card-header">
      <p class="card-header-title">
        <span class="icon">
          <i class="fas fa-tasks" aria-hidden="true"></i>
        </span>
        Tasks ({{ analysis.tasks.length }})
      </p>
      <a
        (click)="collapseTask = !collapseTask"
        data-action="collapse"
        class="card-header-icon is-hidden-fullscreen"
        aria-label="more options"
      >
        <span class="icon">
          <i
            *ngIf="collapseTask"
            class="fas fa-angle-down"
            aria-hidden="true"
          ></i>
          <i
            *ngIf="!collapseTask"
            class="fas fa-angle-left"
            aria-hidden="true"
          ></i>
        </span>
      </a>
    </header>
    <div *ngIf="collapseTask">
      <app-task-list
        [token]="explorerData.selectedAnalysisToken"
        [taskList]="analysis.tasks"
        (tokenChange)="explorerData.openAnalysis($event)"
      >
      </app-task-list>
      <footer class="card-footer">
        <a
          *ngIf="analysis.tasks && analysis.tasks.length > 0"
          (click)="
            analysis.removeAllTasks(); explorerData.selectedAnalysisToken = null
          "
          class="card-footer-item has-text-danger"
          data-tooltip="Delete all tasks."
        >
          <span class="icon">
            <i class="fa fa-trash"></i>
          </span>
          <span> Delete all </span>
        </a>
      </footer>
    </div>
  </div>
</div>

<app-network-menu-dialog [(show)]="explorerData.showNetworkMenuDialog">
</app-network-menu-dialog>

<app-launch-analysis
  [(show)]="explorerData.showAnalysisDialog"
  [target]="explorerData.analysisDialogTarget">
</app-launch-analysis>

<app-custom-genes
  [(show)]="explorerData.showCustomGenesDialog"
  [visibleNodes]="explorerData.activeNetwork.basicNodes"
  (showChange)="(explorerData.showChangeCustomGenes)"
>
</app-custom-genes>

<app-add-expressed-genes
  [(show)]="explorerData.showTissueThresholdDialog"
  [tissue]="explorerData.activeNetwork.selectedTissue"
>
</app-add-expressed-genes>

<app-add-cancer-expressed-genes
  [(show)]="explorerData.showCancerThresholdDialog"
  [selectedExpressionCancerType]="
    explorerData.activeNetwork.selectedExpressionCancerType
  "
  [visibleNodes]="explorerData.activeNetwork.basicNodes"
  [basicNodes]="explorerData.activeNetwork.basicNodes"
  [cancerNodes]="explorerData.activeNetwork.cancerNodes"
>
</app-add-cancer-expressed-genes>

<app-add-mutated-genes
  [(show)]="explorerData.showMutationThresholdDialog"
  [selectedMutationCancerType]="
    explorerData.activeNetwork.selectedMutationCancerType
  "
  [visibleNodes]="explorerData.activeNetwork.basicNodes"
  [basicNodes]="explorerData.activeNetwork.basicNodes"
  [cancerNodes]="explorerData.activeNetwork.cancerNodes"
>
</app-add-mutated-genes>

<app-disease-related-genes
  [(show)]="explorerData.showDiseaseSelectionDialog"
  (showChange)="(explorerData.showChangeDiseaseSelectionDialog)"
  [visibleNodes]="explorerData.activeNetwork.basicNodes"
  [basicNodes]="explorerData.activeNetwork.basicNodes"
  [cancerNodes]="explorerData.activeNetwork.cancerNodes"
>
</app-disease-related-genes>

<app-vcf-input
  [(show)]="explorerData.showVCFInput"
  (showChange)="(explorerData.showChangeVCFInput)"
  (triggerTemplateUpdate)="(explorerData.triggerTemplateUpdateVCFInput)"
>
</app-vcf-input>

<app-task-summarize-dialog
  *ngIf="explorerData.showTaskSummarizeDialog"
></app-task-summarize-dialog>
